import Daily from '@daily-co/daily-js';
import React, { useEffect, useRef, useState } from 'react';
import { BoardInfo } from '../../canvas/BoardInfo';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ProfileModel } from '../../ProfileModel';
import { DailyApi } from './DailyApi';

export const CallLayer = () => {

    const me = useResolve(ProfileModel);
    const board = useEditorSessionObserver(BoardInfo);

    const callContainerRef = useRef<HTMLDivElement>(null);
    const [callFrame, setCallFrame] = useState<any>(null);

    // Initialize the call when we have a board ID
    useEffect(() => {
        const initializeCall = async () => {
            if (board.id && callContainerRef.current && !callFrame) {
                try {
                    // Get or create a room for this board
                    const dailyApi = new DailyApi();
                    const roomName = `board-${board.id}`;
                    const room = await dailyApi.getOrCreateRoom(roomName);

                    if (room) {
                        // Create the call frame
                        const frame = Daily.createFrame(callContainerRef.current, {
                            userName: me.name,
                            iframeStyle: {
                                width: '100%',
                                height: '100%',
                                border: '0',
                                borderRadius: '0px',
                            }
                        });

                        // Set up event handlers
                        frame
                            .on('loaded', () => console.log('Daily iframe loaded'))
                            .on('joined-meeting', async () => {
                                console.log('Joined meeting');

                                // Start transcription after joining the meeting
                                try {
                                    await frame.startTranscription();
                                    console.log('Transcription started');
                                }
                                catch (error) {
                                    console.error('Error starting transcription:', error);
                                }
                            })
                            .on('left-meeting', () => console.log('Left meeting'))
                            .on('error', (e: any) => console.error('Daily error', e))
                            .on('transcription-started', (event: any) => {
                                console.log('Transcription started event:', event);
                            })
                            .on('transcription-message', (event: any) => {
                                // Log transcription messages to the console
                                console.log('Transcription:', event.text);
                                console.log('Full transcription data:', event);
                            });

                        // Join the meeting
                        await frame.join({ url: room.url });

                        // Save the frame reference
                        setCallFrame(frame);
                    }
                }
                catch (error) {
                    console.error('Error initializing video call:', error);
                }
            }
        };

        initializeCall();

        // Clean up when component unmounts
        return () => {
            if (callFrame) {
                callFrame.destroy();
            }
        };
    }, [board.id, callFrame]);

    return (
        <Flexer id="call-layer" absolute inset>
            <div
                ref={callContainerRef}
                style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '0px',
                    overflow: 'hidden'
                }}
            />
        </Flexer>
    );
};

